import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/super-agent',
    name: 'super-agent',
    component: () => import('../views/SuperAgentDetail.vue')
  },
  {
    path: '/super-agent/feature/:id',
    name: 'super-agent-feature',
    component: () => import('../views/SuperAgentFeatureDetail.vue')
  },
  {
    path: '/product-detail',
    name: 'product-detail',
    component: () => import('../views/ProductDetail.vue')
  },
  {
    path: '/scenario-detail',
    name: 'scenario-detail',
    component: () => import('../views/ScenarioDetail.vue')
  },
  {
    path: '/scenarios',
    name: 'scenarios',
    component: () => import('../views/ScenarioList.vue')
  },
  {
    path: '/news-detail',
    name: 'news-detail',
    component: () => import('../views/NewsDetail.vue')
  },
  {
    path: '/news-center',
    name: 'news-center',
    component: () => import('../views/NewsCenter.vue')
  },
  {
    path: '/qualifications',
    name: 'qualifications',
    component: () => import('../views/QualificationsPage.vue')
  },
  {
    path: '/customers',
    name: 'customers',
    component: () => import('../views/CustomersPage.vue')
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: () => import('../views/ContactUs.vue')
  },
  {
    path: '/classic-cases',
    name: 'classic-cases',
    component: () => import('../views/ClassicCases.vue')
  },
  {
    path: '/customer-list',
    name: 'customer-list',
    component: () => import('../views/CustomerList.vue')
  },
  {
    path: '/customer-list/all',
    name: 'customer-list-all',
    component: () => import('../views/CustomerList.vue')
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('../views/ServicesPage.vue')
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 }
  }
})

// 全局路由守卫 - 确保每次路由切换时滚动到顶部
router.beforeEach((to, from, next) => {
  // 等待DOM更新后滚动到顶部
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);
  next();
})

export default router
